import { RouterView } from "vue-router";
import { CheckRouting } from "./check/check.routing";
import { ChangeRouting } from "./change/change.routing";
import { ReceiveRouting } from "./receive/receive.routing";

export const QualityRouting = {
  path: "/quality",
  name: "quality",
  redirect: "/quality/check/list",
  component: RouterView,
  meta: { title: "质量管理", icon: "zhiliang" },
  children: [...CheckRouting, ...ChangeRouting, ...ReceiveRouting],
};
